<template>
  <base-dialog v-model="isVisibleDialog">
    <dialog-template>
      <div slot="content" v-m-b="-10">
        <option-panel
          v-for="(method, idx) in ['POST', 'GET']"
          :key="idx"
          v-m-b="10"
          :active="selectedMethod == method"
          @click="handleSelect(method)"
        >
          <span
            slot="title"
            v-text="method"
          ></span>
        </option-panel>
      </div>
    </dialog-template>
  </base-dialog>
</template>

<script>
import BaseDialog from 'molecules/base/Dialog';
import OptionPanel from 'molecules/panels/OptionPanel';
import DialogTemplate from 'templates/DialogTemplate';

import { EVENT_BUS } from '@/eventBus';

export default {
  name: 'CallbackMessageMethodDialog',
  components: {
    BaseDialog,
    OptionPanel,
    DialogTemplate,
  },
  created() {
    EVENT_BUS.$on('EVENT_SHOW_CALLBACK_MESSAGE_METHOD', this.initialize);
  },
  beforeDestroy() {
    EVENT_BUS.$off('EVENT_SHOW_CALLBACK_MESSAGE_METHOD', this.initialize);
  },
  data() {
    return {
      isVisibleDialog: false,
      selectedMethod: 'POST',
    };
  },
  methods: {
    initialize(callbackMethod) {
      this.selectedMethod = callbackMethod;
      this.isVisibleDialog = true;
    },
    handleSelect(value) {
      this.$emit('select-callback-method', value);
      this.isVisibleDialog = false;
    },
  },
};
</script>
